const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');
const WorkflowActionPane = require('./WorkflowActionPane');

module.exports = class WorkflowActionList extends Builder {
    constructor(title = 'WorkflowActionList') {
        super('workflowPane_WorkflowActionList', title);
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    workflowActionPane(title, properties) {
        let workflowActionPane = new WorkflowActionPane(title, properties);
        this.addChildBlock(workflowActionPane);
        return workflowActionPane;
    }
};
